import Badge from "@mui/material/Badge"
import type { ReactElement } from "react"

export type StatusKey = string | boolean

export type StatusColor = "primary" | "secondary" | "default" | "error" | "info" | "success" | "warning"

export type StatusMap = Map<StatusKey, StatusColor>

const sizeClasses = {
  small: "min-w-2 h-2",
  medium: "min-w-4 h-4",
  large: "min-w-6 h-6",
}
export const StatusIndicator = ({
  status,
  map,
  size = "small",
}: {
  status: StatusKey
  map: StatusMap
  size?: "small" | "medium" | "large"
}): ReactElement => {
  return (
    <Badge
      data-testid={`statusIndicator-${status}`}
      color={map.get(status)}
      badgeContent=''
      classes={{
        root: `block w-fit `,
        standard: `p-0 ${sizeClasses[size]}`,
        colorSuccess: "bg-tertiary-green-500",
        colorSecondary: "bg-gray-500",
        colorInfo: "bg-tertiary-yellow-500",
      }}
      sx={{
        "@media print": {
          "& .MuiBadge-badge": {
            minWidth: "6px",
            height: "6px",
          },
        },
      }}
    />
  )
}
